import clsx from 'clsx';
import { connect } from "react-redux";
import { makeStyles } from 'tss-react/mui';
import { getTypeColor } from "../shared-functions/notification";
import { Fonts } from "../styles/Fonts";
import { Theme247 } from '../styles/Theme247';
import { NotificationTypeUpdated, getNotificationTooltipAndColor } from "../types";
import { useEffect } from 'react';
import { Tooltip } from '@mui/material';
import { truncateWithEllipses } from '../utils/helpers';
import { ReactComponent as PriorityDownIcon } from "../assets/priority-down.svg";
import { ReactComponent as PriorityUpIcon } from "../assets/priority-up.svg";

  const TypeBadge = (props) => {

  let badgeProps = generateBadgeProps(props);

  function generateBadgeProps(props) {
    if (props?.typecode !== null) {
      let text = NotificationTypeUpdated(Number(props?.typecode), props?.notification);   
        return { status: props?.notification?.type === 6 ? ((props?.notification?.hasmaintenancetask && props?.notification?.hasmaintenancetask[0]?.maintenancetask?.hascategory) ? props?.notification?.hasmaintenancetask[0]?.maintenancetask?.hascategory[0]?.maintenancecategory?.colorcode : "#000000") :  getTypeColor(props?.typecode, 'badge') , text: text };
    } else {
      return { status: getTypeColor(undefined, 'badge'), text: 'Undefined badge typecode.' };
    }
  }



  /*
  * Styles
  */
  const useStyles = makeStyles()((theme) => ({
    badge: {
      display: 'flex',
      flexShrink: 1,
      justifyContent: 'center',
      padding: 4,
      borderColor: Theme247.palette.grayShade["300"],
      borderStyle: 'solid',
      borderWidth: 1,
      ...Fonts.RubikRegular,
      fontSize: 12,
      lineHeight: 1.4,
      borderRadius: Theme247.roundness,
      textAlignVertical: 'center',
      textAlign: 'center',
      whiteSpace: 'nowrap'
    },

    /* Badge: Status Types*/
    badgeStatusGray: {
      color: Theme247.palette.grayShade["500"],
      borderColor: Theme247.palette.grayShade["500"],
    },

    badgeStatusMidGray: {
      color: Theme247.palette.grayShade["500"],
      borderColor: Theme247.palette.grayShade["500"],
    },

    badgeStatusGreen: {
      color: Theme247.palette.success.main,
      borderColor: Theme247.palette.success.main,
    },

    badgeStatusOrange: {
      color: Theme247.palette.warning.main,
      borderColor: Theme247.palette.warning.main,
    },

    badgeStatusRed: {
      color: Theme247.palette.error.main,
      borderColor: Theme247.palette.error.main,
    },

    badgeStatusDarkMagenta: {
      color: "#8E24AA",
      borderColor: "#8E24AA",
    },

    cardBadge: {
      marginLeft: 10,
      marginTop: -4,
    },
    badgeContent: {
      display: "inline-flex",
      alignItems: "center",
      gap: 4,
    },
    badgePriorityIcon: {
      width: 16,
      height: 16,
      flexShrink: 0,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
    },
  }));

  const { classes } = useStyles();

  let orderColor = getNotificationTooltipAndColor(props?.notification?.type)?.color;
  const priority = Number(props?.notification?.priority);
  const showDown = props.showPriorityIcon && priority === 1;
  const showUp = props.showPriorityIcon && priority === 2;

  return (
    <div className={clsx(" typeBadge", classes.badge, classes[badgeProps?.status?.class],  props.oncard ? classes.cardBadge : '')} style={{ border : props?.notification?.type === 6 ? "1px solid "+badgeProps.status : "1px solid "+ orderColor, color: props?.notification?.type === 6 ? badgeProps.status : orderColor}}>
       <Tooltip
                title={getNotificationTooltipAndColor(props?.notification?.type)?.tooltip}
              >
                <div className={classes.badgeContent}>
                  {showDown ? (
                    <span className={classes.badgePriorityIcon}>
                      <PriorityDownIcon />
                    </span>
                  ) : null}
                  {showUp ? (
                    <span className={classes.badgePriorityIcon}>
                      <PriorityUpIcon />
                    </span>
                  ) : null}
                  <span>{truncateWithEllipses(badgeProps.text,20)}</span>
                </div>
                </Tooltip> 
    </div>
  );
};

TypeBadge.defaultProps = {
  typecode: null,
  oncard: true,
  notification: undefined,
  showPriorityIcon: false,
};


export default connect(({ isAuthUser, i18n }) => ({ isAuthUser, i18n }), {})(TypeBadge);
